export const SET_LONG_LIVED_PAIRING_CODE_INFO = 'SET_LONG_LIVED_PAIRING_CODE_INFO';

export const SPOT_TV_PAIR_TO_BACKEND_PENDING = 'SPOT_TV_PAIR_TO_BACKEND_PENDING';

export const SPOT_TV_PAIR_TO_BACKEND_FAIL = 'SPOT_TV_PAIR_TO_BACKEND_FAIL';

export const SPOT_TV_PAIR_TO_BACKEND_SUCCESS = 'SPOT_TV_PAIR_TO_BACKEND_SUCCESS';
